export default __webpack_public_path__ + "static/media/dashboard.22cbb19b.png";